import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

export const GlobalStylesArrowSwitcher = createGlobalStyle`
div.ant-picker-panel-layout, div.ant-picker-month-panel {
  width: 18rem !important;
  border-radius: 0.5rem !important;
}
   div.ant-picker-panel {
    height: 19.0625rem !important;
    width: 18rem !important;
    border-radius: 0.5rem !important;
  } 

  div.ant-picker-panel-container, div.ant-picker-month-panel-container {
    border-radius: 0.5rem !important;
  }

 .ant-picker-body, .ant-picker-content { 
    height: 16.5rem !important;
    width: 18rem !important;
  }

  .ant-picker-body {
    flex-grow: 1;
    padding: 0 !important;
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
  }

  td.ant-picker-cell.ant-picker-cell-in-view {
    height: 4.125rem !important;
    padding: 0 !important;
  }

  .ant-picker-cell-inner {
    height: 3.75rem !important;
    line-height: 3.75rem !important;
    width: 3.75rem !important;
    border-radius: 0.5rem !important;
  }

  .ant-picker-header, .ant-picker-header-view {
    height: 2.5624rem !important;
    width: 18rem !important;
    line-height: 2.5624rem !important;
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
    font-size: 1.5rem !important;
  }

  div.ant-picker-header {
    background: ${(props) => props.theme.switcher.headerBackgroundColor} !important;

    div.ant-picker-header-view, div.ant-picker-header-view > button {
      color: ${(props) => props.theme.switcher.fontColor} !important;
      font-family: 'Cormorant Garamond', sans-serif !important;
      font-variant-numeric: lining-nums !important;
      text-transform: uppercase !important;
      /* font-size: 1.1875rem; */

      &:hover {
        color: ${(props) => props.theme.switcher.hoverColor} !important;
      }
    }
  }

  div.ant-picker-body {  
    background: ${(props) => props.theme.switcher.bodyBackgroundColor} !important;;
  }

  div.ant-picker-cell-inner {
    font-family: 'Cormorant Garamond', sans-serif !important;;
    font-variant-numeric: lining-nums !important;
    text-transform: uppercase !important;
    color: ${(props) => props.theme.switcher.fontColor} !important;
  }

//имени месяца
  /* :where(.css-dev-only-do-not-override-161f05s).ant-picker-dropdown .ant-picker-cell .ant-picker-cell-inner {
    font-size: 1rem !important;
    font-weight: 600 !important;
  } */
  .ant-picker-dropdown .ant-picker-cell .ant-picker-cell-inner {
    font-size: 1rem !important;
    font-weight: 600 !important;
  }

//выделенный цвет месяца
  /* :where(.css-dev-only-do-not-override-161f05s).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {
    background: ${(props) => props.theme.switcher.headerBackgroundColor} !important;
    color: ${(props) => props.theme.switcher.fontColor} !important
  } */
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {
    background: ${(props) => props.theme.switcher.headerBackgroundColor} !important;
    color: ${(props) => props.theme.switcher.fontColor} !important;
  }

  span.ant-picker-super-prev-icon, span.ant-picker-super-next-icon {
    color: ${(props) => props.theme.switcher.fontColor} !important;

    &:hover {
      color: ${(props) => props.theme.switcher.hoverColor} !important;
    }
  }
`;

export const StyledContainer = styled.div`
  height: 1.8125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.switcher.background};
  /* gap: 0.625rem; */
  box-sizing: border-box;
  position: relative;

  .datePicker {
    width: 18rem;
    background: none;
    border: none;
    height: 100%;
    text-align: center;
    line-height: 2.375rem;
    text-align: center;
    cursor: pointer;

    &:hover {
      color: ${(props) => props.theme.switcher.hoverColor};
    }

    color: ${(props) => props.theme.switcher.fontColor};
    font-size: 2rem;
    font-family: "Cormorant Garamond", sans-serif;

    font-variant-numeric: lining-nums;
    text-transform: uppercase;
    font-weight: 500;

    input {
      display: inline-block;
      text-align: center;
      line-height: 2.25rem;
      height: 2.25rem;
      font-size: 1.5rem;
      font-variant-numeric: lining-nums;
      text-transform: uppercase;
      font-weight: 500;
      cursor: pointer;
    }

    span.ant-picker-suffix {
      display: none;
    }

    span.ant-picker-clear {
      display: none;
    }
  }
`;

const ButtonStyles = styled.button`
  background: none;
  border: none;
  height: 100%;
  text-align: center;
  line-height: 1.8125rem;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.switcher.hoverColor};
  }
`;

export const StyledButton = styled(ButtonStyles)`
  color: ${(props) => props.theme.switcher.buttonFontColor};
  font-size: 2.5rem;
  font-family: "Consolas", "Courier New", monospace;
  margin-bottom: 0.3125rem;
`;

export const StyledTextButton = styled(ButtonStyles)`
  width: 15.5rem;
  color: ${(props) => props.theme.switcher.textButtonFontColor};
  font-size: 2rem;
  font-family: "Cormorant Garamond", sans-serif;

  font-variant-numeric: lining-nums;
  text-transform: uppercase;
  font-weight: 500;

  span {
    display: inline-block;
    text-align: center;
    line-height: 2.25rem;
    height: 2.25rem;
    font-size: 0.9em;
    font-variant-numeric: lining-nums;
    text-transform: uppercase;
    font-weight: 500;
  }
`;
